if (window.innerWidth <= 1300) {
    function searchclick() {

        document.querySelector('.iww-search-header').classList.toggle('iww-search-header-open');

        if (document.querySelector('.iww-search-header').classList.contains('iww-search-header-open')) {
            document.querySelector('.iww-search-header').style.width = '210px';
            document.querySelector('#search_submit').style.display = 'block';
            document.querySelector('#search_submit').style.opacity = '1';
            document.querySelector('#iww-searchinput').style.display = 'none';
            document.querySelector('.menu').style.display = 'none';
            document.querySelector('.menu').style.opacity = '0';
            document.querySelector('#search_input_header').focus();
        } else {
            setTimeout(function () {
                document.querySelector('.iww-search-header').style.width = '30px';
                document.querySelector('#search_submit').style.display = 'none';
                document.querySelector('#search_submit').style.opacity = '0';
                document.querySelector('.menu').style.display = 'flex';
                document.querySelector('.menu').style.opacity = '1';
                document.querySelector('#iww-searchinput').style.display = 'block';
            }, 400);
        }
    }

    function searchclick_id() {
        const searchHeader = document.querySelector('.iww-search-header-id');
        const searchSubmit = document.querySelector('#search_submit_id');
        const searchInputWrap = document.querySelector('#iww-searchinput-id');
        const searchInput = document.querySelector('#search_input_header_id');

        // Schnellerer Zugriff auf das spezifische Geschwisterelement
        const menuSibling = Array.from(searchHeader.parentNode.children).find(child =>
            child !== searchHeader && child.classList.contains('iww-menu-id')
        );

        const isOpen = searchHeader.classList.toggle('iww-search-header-id-open');

        if (isOpen) {
            searchHeader.classList.add('w-full');
            menuSibling?.classList.add('hidden'); // Optional Chaining nutzen

            searchSubmit.style.cssText = 'display: block; opacity: 1;';
            searchInputWrap.style.display = 'none';

            // Focus direkt ausführen
            searchInput.focus();
        } else {
            setTimeout(() => {
                searchHeader.classList.remove('w-full');
                menuSibling?.classList.remove('hidden');  // Optional Chaining nutzen

                searchSubmit.style.cssText = 'display: none; opacity: 0;';
                searchInputWrap.style.display = 'block';
            }, 400);
        }
    }

    if (document.getElementById('search_submit')) {
        document.getElementById('search_submit').addEventListener('submit', function (evt) {
            let input = document.getElementById('search_input_header').value;
            if (!input.length > 0) {
                searchclick();
                evt.preventDefault();
            }
        });

        document.body.addEventListener('click', function (e) {
            var target = e.target;
            if (
                !target.closest('.iww-search-header') &&
                document.querySelector('.iww-search-header').classList.contains('iww-search-header-open')
            ) {
                searchclick();
            }
        });

        document.addEventListener('keyup', function (evt) {
            let input = document.getElementById('search_input_header').value;

            if (
                evt.keyCode === 27 &&
                !input.length > 0 &&
                document.querySelector('.iww-search-header').classList.contains('iww-search-header-open')
            ) {
                searchclick();
            }
        });
    }


    if (document.getElementById('search_submit_id')) {
        document.getElementById('search_submit_id').addEventListener('submit', function (evt) {
            let input = document.getElementById('search_input_header_id').value;
            if (!input.length > 0) {
                searchclick_id();
                evt.preventDefault();
            }
        });

        document.body.addEventListener('click', function (e) {
            var target = e.target;
            if (
                !target.closest('.iww-search-header-id') &&
                document.querySelector('.iww-search-header-id').classList.contains('iww-search-header-id-open')
            ) {
                searchclick_id();
            }
        });

        document.addEventListener('keyup', function (evt) {
            let input = document.getElementById('search_input_header_id').value;

            if (
                evt.keyCode === 27 &&
                !input.length > 0 &&
                document.querySelector('.iww-search-header-id').classList.contains('iww-search-header-id-open')
            ) {
                searchclick_id();
            }
        });
    }

    document.addEventListener('mouseup', function(event) {
        if (event.target.id === 'iww-searchinput') {
            searchclick(event);
        }
        if (event.target.id === 'iww-searchinput-id') {
            searchclick_id(event);
        }
    }, {once: false});

}

if (document.getElementById('iww-searchinput-article')) {

    document.getElementById('iww-searchinput-article').addEventListener('click', searchclickMobile);

    function searchclickMobile() {
        document.querySelector('.iww-hamburger-spin').setAttribute('aria-hidden', 'true');
        document.getElementById('search_input_header_mobile').focus();
    }
}


if (document.getElementsByClassName('pagination_alphabet_filter')) {

    let alphabetSelection = document.getElementsByClassName('pagination_alphabet_filter');

    for(var i = 0; i < alphabetSelection.length; i++)
    {
        (function (index)
        {
            alphabetSelection[index].addEventListener('click', changeAlphabetUrl)
        })(i);
    }

    function changeAlphabetUrl() {
        let href = document.querySelector('.pagination_alphabet_filter').getAttribute("href");
       // let href = alphabet.getAttribute("href");
        const queryString = window.location.search;
        document.querySelector('.pagination_alphabet_filter').setAttribute('href', href + queryString)
    }
}

window.addEventListener("DOMContentLoaded", function (event) {
    //change search-url bei infodiensten
    document.querySelectorAll('[data-infodienst-kuerzel]').forEach((infodienst) => {
        let kuerzel = infodienst.getAttribute("data-infodienst-kuerzel");
        changesearchurl(kuerzel);
    });

})



function changesearchurl(infodienst_kuerzel){
    let form_search = document.getElementById('search_submit') || null;
    if(form_search) {
        //jetzt url für suche lgp
        form_search.action = "/infodienste/"+infodienst_kuerzel+"/suche";
    }
}
